import type { TemplateViewsGroupedByDate, TemplateViewsGroupedByMarket } from '../model/types';

export const isAntePostTemplateViewGroupedByDate = (
  group: TemplateViewsGroupedByDate | TemplateViewsGroupedByMarket
): group is TemplateViewsGroupedByDate => Array.isArray(group[0]);
